module.exports = __webpack_public_path__ + "static/media/complianceNormal.c91aff45.svg";